import { liveAnalyticsUrl } from "../../const";
import CommonMetabaseDashboard from "../../components/mis/metabase-dashboard/CommonMetabaseDashboard";

const LiveAnalytics = () => {
  return <CommonMetabaseDashboard url={liveAnalyticsUrl} />;
};

export default LiveAnalytics;
